import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from "./routes";
import LocalStorage from 'quasar/src/plugins/LocalStorage.js';;
Vue.use(VueRouter);
var requestRoute = "";
/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default function /* { store, ssrContext } */
() {
  var Router = new VueRouter({
    scrollBehavior: function scrollBehavior() {
      return {
        x: 0,
        y: 0
      };
    },
    routes: routes,
    // Leave these as they are and change in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    mode: process.env.VUE_ROUTER_MODE,
    base: process.env.VUE_ROUTER_BASE
  });
  Router.beforeEach(function (to, from, next) {
    var token = LocalStorage.getItem('token');
    if (to.matched.some(function (record) {
      return record.meta.requiresAuth;
    })) {
      if (!token) {
        next({
          path: '/',
          params: {
            nextUrl: to.fullPath
          }
        });
      } else {
        next();
      }
    } else {
      next();
    }
  });
  Router.afterEach(function (toRoute, fromRoute) {
    if (toRoute.meta.title) document.title = toRoute.meta.title;
  });
  return Router;
}